import { FireCMSPlugin } from "@firecms/core";
import React, { PropsWithChildren, useEffect } from "react";

/**
 * Silme onayında FireCMS tüm alanları basar; diyalog bir kez sadeleştirilir.
 */

const TITLE_LABELS = new Set([
    "Başlık",
    "Liste başlığı",
    "Açıklama",
]);

function findDeleteDialog(root: ParentNode = document): HTMLElement | null {
    const titled = root.querySelector("#delete-dialog-title");
    if (!titled) {
        return null;
    }
    return (
        titled.closest<HTMLElement>("[role='dialog']") ??
        (titled.parentElement?.parentElement as HTMLElement | null)
    );
}

function simplifyDeleteDialog(dialog: HTMLElement): void {
    if (dialog.dataset.octoDeleteSimplified === "1") {
        return;
    }
    dialog.dataset.octoDeleteSimplified = "1";

    const buttons = Array.from(dialog.querySelectorAll("button"));
    const confirmButton = buttons[buttons.length - 1];
    if (
        confirmButton &&
        confirmButton.textContent?.trim() !== "Vazgeç" &&
        confirmButton.textContent?.trim() !== "Sil"
    ) {
        confirmButton.textContent = "Sil";
    }

    dialog.querySelectorAll<HTMLElement>(".grid.grid-cols-12").forEach((row, index) => {
        const label =
            row.querySelector(".col-span-4")?.textContent?.trim() ?? "";
        const keepFirstId = label === "ID" && index === 0;
        const keepTitle = TITLE_LABELS.has(label);
        if (!keepFirstId && !keepTitle) {
            row.style.display = "none";
        }
    });

    dialog.querySelectorAll("span").forEach((span) => {
        const text = span.textContent?.trim();
        if (
            text === "Mesajlar" ||
            text === "Sorular" ||
            text === "Şıklar"
        ) {
            const section = span.parentElement;
            if (section && !section.classList.contains("grid")) {
                section.style.display = "none";
            }
        }
    });
}

function DeleteConfirmProvider({ children }: PropsWithChildren) {
    useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                for (const node of mutation.addedNodes) {
                    if (!(node instanceof HTMLElement)) {
                        continue;
                    }
                    const dialog =
                        node.id === "delete-dialog-title"
                            ? findDeleteDialog()
                            : findDeleteDialog(node);
                    if (dialog) {
                        observer.disconnect();
                        simplifyDeleteDialog(dialog);
                        observer.observe(document.body, {
                            childList: true,
                            subtree: true,
                        });
                        return;
                    }
                }
            }
        });

        const existing = findDeleteDialog();
        if (existing) {
            simplifyDeleteDialog(existing);
        }

        observer.observe(document.body, { childList: true, subtree: true });
        return () => observer.disconnect();
    }, []);

    return <>{children}</>;
}

export const deleteConfirmPlugin: FireCMSPlugin = {
    key: "delete-confirm",
    provider: {
        Component: DeleteConfirmProvider,
    },
};
